import defaultTo from 'lodash/defaultTo';
import parseInt from 'lodash/parseInt';
import React, { useCallback, useEffect, useRef } from 'react';

import ModalDataSlider from './ModalDataSlider';

const DATA_FROM = 'From ';

const DataTab = ({
    currentData,
    values,
    includedDataLabel,
    dataLabel,
    dataFormat,
    buttonsContentFragment,
    changeData
}) => {
    const buttonsContainerRef = useRef(null);

    const valuesWithFrom = (values || []).map((value, index) => {
        const isFirstOrLast = index === 0 || index === (values || []).length - 1;
        const label = isFirstOrLast ? value.value : `${DATA_FROM}${value.value}`;
        return {
            key: value.key,
            value: label,
            title: label
        };
    });

    const handleOnMount = useCallback(() => {
        const buttonsContainer = wo$(buttonsContainerRef.current);
        buttonsContainer
            .find('[data-min-data]')
            .off('click')
            .click(e => {
                const value = defaultTo(parseInt(e.currentTarget.dataset.minData), null);
                changeData(value);
            });
    }, [changeData]);

    useEffect(() => handleOnMount(), [handleOnMount]);

    return (
        <>
            <div className="row pad-t-2 mar-b-3">
                <div className="col-md-24">
                    <h5 className="font-6 mar-0">{includedDataLabel}</h5>
                </div>
            </div>
            <div className="row mar-y-5 pad-b-6">
                <div className="col-xs-24 col-sm-12 col-md-8">
                    <ModalDataSlider
                        current={currentData}
                        values={valuesWithFrom}
                        dataLabel={dataLabel}
                        dataFormat={dataFormat}
                        changeData={changeData}
                    />
                </div>
            </div>
            <div
                ref={buttonsContainerRef}
                className="row mar-b-5"
                dangerouslySetInnerHTML={{ __html: buttonsContentFragment }}
            />
        </>
    );
};

export default DataTab;
